import React, { useState } from "react";
import axios from "axios";

const DailyReport = ({ userDetails }) => {
  const [responseMessage, setResponseMessage] = useState(false);
  const [formData, setFormData] = useState({
    visit_date: "",
    site: "",
    reason: "",
    places: "",
  });

  // handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const updatedData = { ...formData, user_id: userDetails.id };

    try {
      await axios.post(
        "https://api.swalokgroup.com/api/daily-report",
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setResponseMessage("Report Submitted.");
      setTimeout(() => {
        setResponseMessage("");
        setFormData({ visit_date: "", site: "", reason: "", places: "" });
      }, 1000);
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <>
      <section className="py-5 px-4">
        <div className="sec-subheading">
          <hr />
          <span>Add Daily Report</span>
          <hr />
        </div>
        <div className="profile-area-inner mt-4">
          <p className="profile-heading">Add Report</p>

          <form className="row g-3 py-4 px-4" onSubmit={handleSubmit}>
            <div className="col-12">
              <label htmlFor="Visit Date" className="text-muted">
                Visit Date
              </label>
              <input
                type="date"
                className="form-input"
                name="visit_date"
                value={formData.visit_date}
                placeholder="Visit Date"
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12">
              <label htmlFor="Site Name" className="text-muted">
                Site Name
              </label>
              <input
                type="text"
                className="form-input"
                name="site"
                value={formData.site}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12">
              <label htmlFor="Reason" className="text-muted">
                Visit Reason
              </label>
              <input
                type="text"
                className="form-input"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12">
              <label htmlFor="Places Visited" className="text-muted">
                Places Visited
              </label>
              <input
                type="text"
                className="form-input"
                name="places"
                value={formData.places}
                placeholder="(seperate places using commas)"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-12 my-4 text-end">
              <button type="submit" className="admin-btn py-2 px-3 rounded">
                Submit Report
              </button>
            </div>
          </form>
          {/* form ends */}
        </div>
        {responseMessage && (
          <div className="response-message d-flex justify-content-between">
            <p className="my-0 mx-auto">{responseMessage}</p>
            <p
              className="my-0 cursor-pointer"
              onClick={() => setResponseMessage(false)}
            >
              <i className="fa-solid fa-xmark"></i>
            </p>
          </div>
        )}
      </section>
    </>
  );
};

export default DailyReport;
